import { render } from "./WordFreq.vue?vue&type=template&id=0a2e2a78&scoped=true"
import script from "./WordFreq.vue?vue&type=script&lang=js"
export * from "./WordFreq.vue?vue&type=script&lang=js"

import "./WordFreq.vue?vue&type=style&index=0&id=0a2e2a78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2e2a78"]])

export default __exports__